<template>
  <div class="message-box-wrap el-msg" id="messageNode" :class="[hasMask ? '' : 'no-mask', ownClass ? ownClass : '']"
    v-if="showMsgBox">
    <iframe id="iframe" src="about:blank" frameborder="0" marginheight="0" marginwidth="0" style="
        position: absolute;
        visibility: inherit;
        top: undefined;
        left: undefined;
        height: 100%;
        width: 100%;
        z-index: -1;
        filter: alpah(opactiy=0);
      "></iframe>
    <article :class="[
        'message-wrap',
        { 'message-wrap--alert': typeMessage === 'alert' },
        { 'message-wrap--custeval': typeMessage === 'custEval' },
        {
          'message-wrap--relationship': typeMessage === 'relationshipMsg',
        },
        { 'message-wrap--threeElement': typeMessage === 'threeElement' },
        { 'message-wrap--readCardMsg': typeMessage === 'readCardMsg' },
      ]">
      <!---- error content ----->
      <section class="content">
        <div v-if="typeMessage === 'alert' || typeMessage === 'confirm'">
          <div class="alertTitle">{{title}}
            <!-- <img @click="canceled" class="alert-close" src='@img/newCode/alert/icon-close.svg' /> -->
          </div>
          <div class="messageContent">
            <div class="msg-icon" :class="msg_icon"></div>
            <div class="messageTextList">
              <span v-for="item in text" :key="item" :class="['message-text', { 'message-label': true }]"
                v-html="item"></span>
            </div>
          </div>
        </div>

        <error-content v-if="typeMessage === 'error'" :title="error_title" :info="error_info" :text="voiceText">
        </error-content>

        <user-msg-content v-if="typeMessage === 'userMsg'" :img="userMsg.user_img" :enter_name="userMsg.enter_name"
          :return_name="userMsg.return_name" :enter_code="userMsg.enter_code" :return_code="userMsg.return_code">
        </user-msg-content>
<!--
        <eval v-if="typeMessage === 'eval'" :title="evaluate.title" :info="evaluate.info" :lv="evaluate.lv"
          :point="evaluate.point"></eval> -->

        <cust-eval v-if="typeMessage === 'custEval'" :title="custEvaluate.title" :lv="custEvaluate.lv"
          :score="custEvaluate.score" :lvDate="custEvaluate.lvDate" :lvExpDate="custEvaluate.lvExpDate"
          :remainingEval="custEvaluate.remainingEval"></cust-eval>

        <relationship-msg v-if="typeMessage === 'relationshipMsg'" :title="relationshipMsg.title"
          :szTips="relationshipMsg.szTips" :shTips="relationshipMsg.shTips" @canceled="canceled"></relationship-msg>

        <pass-word v-if="typeMessage === 'password'" @success="showConfirm" :title="password.title" :pwd="password.pwd"
          :info="password.info" :CUST_CODE="password.CUST_CODE" :scope="password.scope"
          :isSecondCheck="password.isSecondCheck"></pass-word>

        <three-element v-if="typeMessage === 'threeElement'" :title="threeElement.title"
          :custInfo="threeElement.custInfo"></three-element>

        <exs-tip v-if="typeMessage === 'exsTip'" :title="exsTip.title" :dialogFormVisible="exsTip.dialogFormVisible"></exs-tip>

        <read-card-msg v-if="typeMessage === 'readCardMsg'" :readCardMsg="readCardMsg"></read-card-msg>
        <check-code v-if="typeMessage === 'checkCode'" :checkCode="checkCode" @additonalAction="additonalAction">
        </check-code>
        <show-tips v-if="typeMessage === 'showTips'" :title="showTips.title" :tips="showTips.tips"></show-tips>
        <!-- <cry v-if="typeMessage === 'cry'" :name="cry.name" :day="cry.day"></cry> -->
        <macAddress v-if="typeMessage === 'macAddress'"></macAddress>
      </section>

      <!----------- button wrap ----------------->
      <!-- <footer>
        <div class="confirm-wrap">
          <button id="cancel-btn" @click="canceled" class="commombtn cancel-btn" v-if="cancelText">
            <i v-show="cancel_icon.length > 0" class="btn-icon cancel-icon" :class="cancel_icon"></i>
            {{ cancelText }}
          </button>
          <button id="confirm-btn" class="commombtn confirm-btn" @click="confirmed" v-if="confirmText">
            <i v-show="confirm_icon.length > 0" class="btn-icon confirm-icon" :class="confirm_icon"></i>
            {{ confirmText }}
          </button>
        </div>
      </footer> -->
      <el-footer class="operator-footer-btn-group">
        <el-button  v-if="cancelText" id="cancel-btn" class="btn-icon cancel-icon light-button" :class="cancel_icon" round @click="canceled">
          {{ cancelText }}</el-button>
        <el-button  v-if="confirmText" id="confirm-btn" class="btn-icon confirm-icon light-button-save" :class="confirm_icon" round @click="confirmed">
        {{ confirmText }}</el-button>
    </el-footer>
    </article>
  </div>
</template>

<script type="text/babel">
/*
*@author liwei
*@author lianjf
*
* @param {string}     msg_icon                  提示图标       [reset, submit, edit, cancel | alert, question, warn, card-error(证件有误)]
* @param {string}     confirm_icon              确认按钮图标   [reload, upload, edit, smile,go]
* @param {string}     cancel_icon               取消按钮图标   [ smile, cancel, account(账号登录)，check(查看校验结果), refresh(刷新), service(呼叫人工)]
*
* @param {boolean}    showMsgBox                显示提示框
* @param {string}     ownClass                  自定义class
* @param {boolean}    hasMask                   是否有遮罩层
*
* @param {string}     title                     标题
* @param {string}     messageText               提示文字
* @param {string}     cancelButtonText          取消按钮文字
* @param {string}     confirmButtonText         确认按钮文字
* @param {function}   confirmedAction           确认按钮操作的回调函数
* @param {function}   canceledAction            取消按钮事件
*

*使用方法
  this.alert("我正在加载中有完没完啊，我正在加载中")
  this.confirm({
    hasMask:true,
    messageTitle:"我是标题",
    messageText:'我正在加载中有完没完啊，我正在加载中',
    msg_icon: "reset",
    confirm_icon: "",
    cancel_icon: "",
    confirmButtonText:'重新测评',
    cancelButtonText:'取消',
    ownClass:'movi',
    confirmedAction:function(){consoleLog("可选的确认按钮点击事件")}
    canceledAction:function(){consoleLog("可选的取消按钮点击事件")}
  })

* this.alert('提示框')
*
*
*/
import ErrorContent from "./content/error";
import UserMsgContent from "./content/userMsg";
// import Eval from "./content/evaluate";
import PassWord from "./content/password";
import CustEval from "./content/custEvaluate";
import RelationshipMsg from "./content/relationshipMsg";
import ThreeElement from "./content/threeElement";
import readCardMsg from "./content/readCardMsg";
import checkCode from "./content/checkCode";
import showTips from "./content/showTips";
import ExsTip from "./content/exsTip";
// import Cry from "./content/cry";
import macAddress from "./content/macAddress";
export default {
  name: "kui-message",
  components: {
    ErrorContent,
    UserMsgContent,
    // Eval,
    PassWord,
    CustEval,
    RelationshipMsg,
    ThreeElement,
    ExsTip,
    readCardMsg,
    checkCode,
    showTips,
    // Cry,
    macAddress
  },
  data () {
    return {
      hasMask: true,
      messageText: "",
      messageTitle:"",
      typeMessage: "alert",
      cancelButtonText: "取消",
      confirmButtonText: "确定",
      showMsgBox: false,
      noPlayVoice: false,
      voiceFullyMatch: false,
      ownClass: "",
      validType: "",

      error_title: "",
      error_info: "",
      msg_icon: "alert",
      confirm_icon: "",
      cancel_icon: "cancel",

      evaluate: { //评测弹框
        messageTitle: "",
        lv: "",
        info: "",
        point: 0
      },

      userMsg: {
        user_img: "",
        enter_name: "",
        return_name: "",
        enter_code: "",
        return_code: ""
      },
      password: {
        title: "",
        info: "",
        psd: "",
        scope: "1",
        CUST_CODE: ""
      },
      readCardMsg: {
        title: "系统信息校验结果",
        custName: "",
        custIdCode: "",
        cardName: "",
        cardIdCode: ""
      },
      checkCode: {
        title: "请输入验证码",
        imgSrc: ""
      },
      showTips: {
        title: "",
        tips: [],
      },
      // cry: {
      //   name: "",
      //   day: ""
      // },
      exsTip: {
        title: "",
        dialogFormVisible: false
      },
      macAddress:{
        title: "",
        info: "",
        psd: "",
        scope: "1",
        CUST_CODE: ""
      }
    };
  },
  computed: {
    text () {
      return this.messageText.split("&");
    },
    title () {
      return this.messageTitle.trim() || "提示";
    },
    voiceText () {
      return this.messageText.split("&").join("");
    },
    confirmText () {
      return this.confirmButtonText;
    },
    cancelText () {
      return this.cancelButtonText;
    }
  },
  watch: {
    showMsgBox (val) {
      if (!val) {
        this.showTips.title = "";
        this.showTips.tips = [];
        this.messageText = "";
      }
    },
    //解决嵌套弹窗不播报话术的问题@zhaoyr
    voiceText (val) {
    }
  },
  methods: {
    showConfirm (show) {
      this.confirmButtonText = show ? "确定" : "";
      // this.cancelButtonText = show ? null : '取消';
      if (show) {
        this.cancelTextBak = this.cancelButtonText;
        this.cancelButtonText = null;
      } else {
        this.cancelButtonText = this.cancelTextBak || this.cancelButtonText || "取消";
      }
    },
    confirmed: _.throttle(function () {
      this.showMsgBox = false;
      if (this.confirmedAction) {
        this.confirmedAction();
      } else {
        this.$emit("confirmed");
      }
    }, 200, { "trailing": false }),
    canceled () {
      this.showMsgBox = false;
      if (this.canceledAction) {
        this.canceledAction();
      } else {
        this.$emit("canceled");
      }
    },
    additonalAction () {
      this.$emit("additonalAction");
    }
  }
};
</script>


<style lang="less" scoped>
@import "~@/styles/less/variable.less";
.message-box-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5000;
  background: rgba(0, 0, 0, 0.6);
  &.no-mask {
    background: none;
  }
}
.message-wrap {
  // box-sizing: border-box;
  position: relative;
  margin: 0 auto;
  min-height: 1rem;
  text-align: center;
  background: #fff;
  overflow: hidden;
  max-width: 35%;
  min-width: 400px;
  z-index: 9;
  border-radius: 5px;
  padding: 0;
  &.message-wrap--alert {
    .btn-icon {
      &.check {
        background-image: url("~@img/flow_reuse/dialog/icon_jianyan.png");
      }
    }
  }
  .msg-icon {
    width: 32px;
    height: 32px;
  }
  // box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.25);
  .content {
    box-sizing: border-box;
    max-height: 800px;
    overflow: auto;
    .messageContent{
      display: flex;
      justify-content: center;
      height: 100%;
      align-items: center;
      min-height: 40px;
      margin: 30px 30px;
      position: relative;
      flex-wrap: wrap;
    }
    .alert-close{
      position: absolute;
      top: 10px;
      right:10px;
    }
    //  .alertTitle {
    //   display: flex;
    //   align-items: center;
    //   justify-content: space-between;
    //   text-align: left;
    //   padding-left: 20px;
    //   // font-size: 16px;
    //   color: #D0AA72;
    //   letter-spacing: 1px;
    //   line-height: 42px;
    //   height: 42px;
    //   font-weight: 600;
    //   background-image: linear-gradient(90deg, #F4E4CE 0%, #FFFFFF 100%);
    //   .fontsize-title-small();
    // }
  }
  .message-text {
    box-sizing: border-box;
    font-size: 14px;
    color: #000;
    letter-spacing: 1px;
    line-height: 1.2;
    width: 100%;
    display: flex;
    text-align: left;
    display: block;
  }
  .msg-icon{
    background: url("~@img/newCode/alert/icon_warn.svg") no-repeat;
    background-size: 30px 30px;
    display: block;
    margin-right: 10px;
  }
  .messageTextList{
    display: flex;
    width: 80%;
    word-wrap: break-word;
    flex-wrap: wrap;
  }
  .message-text:not(:first-child){
    // margin-left: 42px;
    display: flex;
  }
  footer{
    width: 100%;
    height: 60px;
  }
  .confirm-wrap {
    display: flex;
    width: 100%;
    border-top: 1px solid #c3c5cd;

    height: 32px;
    justify-content: flex-end;
    flex: 0;
    border: 0;
    margin-bottom: 18px;
    box-sizing: content-box;

    .commombtn {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-grow: 1;
      outline: none;
      border-radius: 2px;
      width: 86px;
      height: 32px;
      flex: 0 0 88px;
      font-size: 14px;
      margin-right: 18px;
      border: 0;
      &.cancel-btn {
        background: white;
        color: #4667e9;
        border:1.5px solid #4667e9;
        padding: 0 20px;
        flex: 0 0 auto;
        width: auto;
      }
      &.confirm-btn{
        background: #2D8CF0;
        color: white;
        padding: 0 20px;
        flex: 0 0 auto;
        width: auto;
      }
      // .btn-icon {
      //   display: block;
      //   // width: 34px;
      //   height: 34px;
      //   margin-right: 10px;
      //   background-size: 100% auto;
      // }
    }


  }
  &.message-wrap--relationship {
    width: 1000px;
    min-height: 800px;
    .content {
      padding: 0;
    }
    .confirm-wrap {
      align-items: center;
      justify-content: center;
      .confirm-btn {
        .confirm-icon {
          display: none;
        }
        flex: 0 0 220px;
        height: 80px;
        font-size: 14px;
        font-weight: 500;
        color: #fff;
        background: linear-gradient(
          45deg,
          rgba(53, 86, 221, 1),
          rgba(70, 103, 233, 1)
        );
        border-radius: 4px;
      }
    }
  }
  &.message-wrap--readCardMsg {
    .content {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/ui/default/message/src/message.vue